export default {
  search_placeholder: "FAQs durchsuchen...",
  no_results_title: "Keine Ergebnisse gefunden",
  no_results_subtitle:
    "Versuchen Sie, Ihre Suchbegriffe anzupassen oder durchsuchen Sie die Kategorien auf der linken Seite.",
  search_cleared_message: "Suche gelöscht, um vollständigen Inhalt anzuzeigen",
  still_have_questions: {
    before_email: "Noch Fragen? Kontaktieren Sie uns unter ",
    after_email: " — unser Team antwortet innerhalb von 24 Stunden.",
  },
};
